var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['canvas-control', _vm.orientation]},[(_vm.canvasRotate)?_c('i',{staticClass:"fa fa-retweet canvas-control--rotate-button",on:{"click":_vm._rotateCanvas}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }